"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require("material-ui/styles/colors");

var palette = {
  primary1Color: "#83a441",
  primary2Color: "#657d32",
  primary3Color: "#cbd4b6",
  accent1Color: "#806643",
  accent2Color: _colors.grey100,
  accent3Color: _colors.grey300,
  disabledColor: "rgba(0, 0, 0, 0.4)"
};

exports["default"] = {

  palette: palette,

  timePicker: {
    headerColor: palette.primary1Color
  },

  datePicker: {
    headerColor: palette.primary1Color
  },

  inkBar: {
    backgroundColor: _colors.orange500
  },

  menuBarButton: {
    hoverColor: "#4e6030"
  },

  speedButton: {
    backgroundColor: "#6b8535"
  }

};


//////////////////
// WEBPACK FOOTER
// ./program/frontend/application/theme.js
// module id = 880
// module chunks = 0